import React, { useState } from "react";
import { Button, Form, Modal, Col } from "react-bootstrap";
import { useFormik } from "formik";
import { masterPasswordSchema } from "../helpers/yup_validator";
import { post } from "../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import { masterAuthSuccess } from "../store/login";
import add_stock from "../Assets/svg/stockExchange/add_stock.svg";
import visiblePass from "../Assets/svg/login/visible-pass.svg";
import nonVisiblePass from "../Assets/svg/login/non-visible-pass.svg";
import pwd from "../Assets/svg/login/password.svg";
import { Link } from "react-router-dom";
import { ADMIN_ROLE_ID } from "../helpers/constants";

const MasterPasswordPopup = ({
  showModal,
  setShowModal,
  onClickReset,
  sendOtpLoading
}) => {
  const user = useSelector(state => state.login.userData);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState();

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: masterPasswordSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const response = await post("/user/admin/master-auth", values);
        if(response?.success) {
          dispatch(masterAuthSuccess({
            token: response?.data?.token
          }))
        }
      } catch (error) {
        console.error("Error veriying master password:", error);
      }
    },
  });

  return (
    <Modal
      show={showModal}
      size="md"
      onHide={() => setShowModal(false)}
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Body>
        <div className="topHeader d-flex align-items-start justify-content-between gap-10 pb-2">
          <div className="left">
            <h5 className="m-0 fw-sbold">
              Unlock with Master Password
            </h5>
            <p className="m-0 text-muted">
              Enter your master password to unlock this section
            </p>
          </div>
          <Button
            className="p-0 border-0"
            variant="transparent"
            onClick={() => setShowModal(false)}
          >
            <img src={add_stock} alt="" />
          </Button>
        </div>
        <div className="FormWrapper">
          {formik.errors.submissionError && (
            <div className="alert alert-danger">
              {formik.errors.submissionError}
            </div>
          )}
          <Form onSubmit={formik.handleSubmit} autocomplete="off">
            <Col className="py-2 mt-3" lg="12">
              <div className="position-relative labelInput">
                <div className="iconWithText position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="form-control "
                    placeholder="********"
                    autoComplete="off"
                  />
                  <span className="icn position-absolute" style={{ left: "8px" }}>
                    <img src={pwd} alt="" />
                  </span>
                  <Button
                    onClick={() =>
                      setShowPassword(!showPassword)
                    }
                    variant="transparent"
                    className="border-0 p-0 icn position-absolute"
                    style={{ right: "8px" }}
                  >
                    {showPassword ? (
                      <img src={visiblePass} alt="" />
                    ) : (
                      <img src={nonVisiblePass} alt="" />
                    )}
                  </Button>
                </div>
                <label
                  htmlFor=""
                  className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                >
                  Password
                </label>
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-danger">{formik.errors.password}</div>
                ) : null}
              </div>
            </Col>
            <Col lg="12" className="py-2 mt-3">
              <Button
                className="d-flex align-items-center w-100 justify-content-center commonBtn"
                type="submit"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? "Please wait..." : "Submit"}
              </Button>
            </Col>
          </Form>
          {user?.role === ADMIN_ROLE_ID && (
            <div className="text-center">
              <Link
                onClick={onClickReset}
                className="themeClr"
              >
                {sendOtpLoading ? "Please wait..." : "Forgot Password?"}
              </Link>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MasterPasswordPopup;
